import { Badge } from "@/components/ui/badge";
import { ShieldCheck, Zap, Star, ThumbsUp, Award, Route } from "lucide-react";

export const getDriverBadges = ({ verified, priority, rating = 0, reviews = 0, trips = 0 }) => {
  const b = [];
  if (verified) b.push({ key: "verified", label: "Terverifikasi", icon: ShieldCheck, cls: "bg-emerald-500/15 text-emerald-400 hover:bg-emerald-500/15" });
  if (priority) b.push({ key: "priority", label: "Prioritas", icon: Zap, cls: "bg-primary/15 text-primary hover:bg-primary/15" });
  if (rating >= 4.8 && reviews >= 5) b.push({ key: "topstar", label: "Bintang Terbaik", icon: Star, fill: true, cls: "bg-yellow-500/15 text-yellow-400 hover:bg-yellow-500/15" });
  else if (rating >= 4.5 && reviews >= 3) b.push({ key: "highrating", label: "Rating Tinggi", icon: Star, fill: true, cls: "bg-yellow-500/15 text-yellow-400 hover:bg-yellow-500/15" });
  if (reviews >= 20) b.push({ key: "trusted", label: "Driver Terpercaya", icon: ThumbsUp, cls: "bg-sky-500/15 text-sky-400 hover:bg-sky-500/15" });
  if (trips >= 100) b.push({ key: "trips", label: "100+ Perjalanan", icon: Award, cls: "bg-violet-500/15 text-violet-400 hover:bg-violet-500/15" });
  else if (trips >= 50) b.push({ key: "trips", label: "50+ Perjalanan", icon: Award, cls: "bg-violet-500/15 text-violet-400 hover:bg-violet-500/15" });
  else if (trips >= 10) b.push({ key: "trips", label: "10+ Perjalanan", icon: Route, cls: "bg-violet-500/15 text-violet-400 hover:bg-violet-500/15" });
  return b;
};

export const DriverBadges = ({ verified, priority, rating, reviews, trips, size = "sm", testId }) => {
  const badges = getDriverBadges({ verified, priority, rating, reviews, trips });
  if (!badges.length) return null;
  const iconSize = size === "xs" ? "h-2.5 w-2.5" : "h-3 w-3";
  const txt = size === "xs" ? "text-[9px]" : "text-[10px]";
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {badges.map((b) => {
        const Icon = b.icon;
        return (
          <Badge key={b.key} className={`h-5 gap-0.5 px-1.5 font-bold ${txt} ${b.cls}`} data-testid={`badge-${b.key}`}>
            <Icon className={`${iconSize} ${b.fill ? "fill-current" : ""}`} /> {b.label}
          </Badge>
        );
      })}
    </div>
  );
};
